import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';

interface GeneralListsListIssueCountSignature {
  Args: {
    isLoading: boolean;
    itemIssueCount: number;
  };
}

export default class GeneralListsListIssueCount extends Component<GeneralListsListIssueCountSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get label() {
    const count = this.args.itemIssueCount;
    return this.intl.t('general.issues', { count });
  }

  <template>
    <div class="item-issue-count text-400--regular">
      <div class="list-item-issue-count">
        {{#if @isLoading}}
          <div class="issue-count-loading-bar-container">
            <div class="table-loading-state-bar"></div>
          </div>
        {{else}}
          {{@itemIssueCount}}
        {{/if}}
      </div>
      <div class="list-item-subtext text-200--regular capitalize">
        {{this.label}}
      </div>
    </div>
  </template>
}
